module.exports = __webpack_public_path__ + "static/media/musical_training_toddler_parents.792d38d4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/musical_training_toddler_parents.jpg
// module id = 1272
// module chunks = 0